<!-- eslint-disable max-len -->
<template>
  <div>
    <div class="block relative w-full mt-2">
      <div class="body_inners pl-4 pr-4">
        <div class="block top-block mb-4">
          <h2
            class="
              block
              text-darkgreen text-sm
              font-bold
              m-0
              title-block
              text-center text-danger
              pl-4
              pr-4
            "
          >
            {{ $t("pages.dont_show_family.another_application") }}
          </h2>
        </div>
        <div
          class="list-items block relative"
          @click="
            $router.push({
              name: 'offerDetails',
              params: { id: details.offer.offer_id },
            })
          "
        >
          <div
            class="
              block
              relative
              walter-block
              bg-white
              rounded-lg
              walter-shadow
            "
          >
            <div class="flex top-block pt-4 pb-3 pl-3 pr-4">
              <div class="left-block w-2/4 relative">
                <h4 class="block relative text-sm font-bold text-darkblack">
                  {{ details.offer.customer.last_name }}/{{
                    details.offer.customer.first_name
                  }}
                </h4>
                <p
                  class="
                    flex
                    align-center
                    justify-start
                    mt-2
                    mb-0
                    text-xs
                    font-medium
                    text-darkgray1
                  "
                >
                  <span class="mr-1">
                    <svg
                      class="w-3.5 h-3.5"
                      viewBox="0 0 10 12"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M4.99984 0.666992C2.2667 0.666992 0.0415039 2.89219 0.0415039 5.62533C0.0415039 6.85231 0.491635 7.97757 1.23096 8.84277L1.23324 8.84505L1.23494 8.84733C1.23494 8.84733 3.34426 11.2542 4.09522 11.9708C4.59809 12.4502 5.40102 12.4502 5.90389 11.9708C6.75987 11.1544 8.7653 8.84619 8.7653 8.84619L8.76644 8.84448L8.76815 8.84277C9.50813 7.97756 9.95817 6.85231 9.95817 5.62533C9.95817 2.89219 7.73297 0.666992 4.99984 0.666992ZM4.99984 1.54199C7.26004 1.54199 9.08317 3.36513 9.08317 5.62533C9.08317 6.63893 8.71379 7.55983 8.10278 8.27425C8.09881 8.2788 6.04693 10.6255 5.30005 11.3379C5.12684 11.503 4.87227 11.503 4.69906 11.3379C4.07484 10.7423 1.90266 8.28143 1.89632 8.27425L1.89575 8.27368C1.28556 7.55932 0.916504 6.63865 0.916504 5.62533C0.916504 3.36513 2.73964 1.54199 4.99984 1.54199ZM4.99984 3.87533C4.45296 3.87533 3.98741 4.09616 3.68848 4.43245C3.38955 4.76875 3.24984 5.19998 3.24984 5.62533C3.24984 6.05067 3.38955 6.4819 3.68848 6.8182C3.98741 7.15449 4.45296 7.37533 4.99984 7.37533C5.54671 7.37533 6.01227 7.15449 6.3112 6.8182C6.61013 6.4819 6.74984 6.05067 6.74984 5.62533C6.74984 5.19998 6.61013 4.76875 6.3112 4.43245C6.01227 4.09616 5.54671 3.87533 4.99984 3.87533ZM4.99984 4.75033C5.32796 4.75033 5.51866 4.85762 5.65723 5.01351C5.7958 5.1694 5.87484 5.39442 5.87484 5.62533C5.87484 5.85623 5.7958 6.08125 5.65723 6.23714C5.51866 6.39303 5.32796 6.50033 4.99984 6.50033C4.67171 6.50033 4.48102 6.39303 4.34245 6.23714C4.20388 6.08125 4.12484 5.85623 4.12484 5.62533C4.12484 5.39442 4.20388 5.1694 4.34245 5.01351C4.48102 4.85762 4.67171 4.75033 4.99984 4.75033Z"
                        fill="#676666"
                      />
                    </svg>
                  </span>
                  {{ details.offer.location }}
                </p>
              </div>
              <div class="right-block w-2/4 relative">
                
                <p
                  class="
                    wishlist-icon
                    relative
                    text-sm text-right
                    flex
                    items-center
                    justify-end
                    mt-0
                    font-bold
                  "
                >
                  <span class="flex mr-1.5">
                    <svg
                      class="w-3.5 h-3.5"
                      viewBox="0 0 12 14"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M7.00016 0.833008C3.32418 0.833008 0.333496 3.8237 0.333496 7.49967C0.333496 11.1757 3.32418 14.1663 7.00016 14.1663C10.6761 14.1663 13.6668 11.1757 13.6668 7.49967C13.6668 3.8237 10.6761 0.833008 7.00016 0.833008ZM7.17334 3.83301C8.49667 3.83301 9.06307 4.39182 9.51774 4.84082C9.71441 5.03482 9.7163 5.35118 9.5223 5.54785C9.32863 5.74452 9.01127 5.74641 8.81527 5.55241C8.40827 5.15074 8.08699 4.83301 7.17399 4.83301C6.37166 4.83301 5.67077 5.37067 5.29443 6.16634H6.8335C7.1095 6.16634 7.3335 6.39001 7.3335 6.66634C7.3335 6.94267 7.1095 7.16634 6.8335 7.16634H5.01904C5.00771 7.27567 5.00016 7.38667 5.00016 7.49967C5.00016 7.61267 5.00771 7.72367 5.01904 7.83301H6.8335C7.1095 7.83301 7.3335 8.05667 7.3335 8.33301C7.3335 8.60934 7.1095 8.83301 6.8335 8.83301H5.29443C5.6711 9.62867 6.37101 10.1663 7.17334 10.1663C8.08634 10.1663 8.40793 9.84861 8.81527 9.44694C9.01127 9.25294 9.32863 9.25516 9.5223 9.4515C9.7163 9.64816 9.71441 9.96486 9.51774 10.1585C9.06307 10.6079 8.49699 11.1663 7.17399 11.1663C5.83132 11.1663 4.68353 10.1967 4.22087 8.83301H3.50016C3.22416 8.83301 3.00016 8.60934 3.00016 8.33301C3.00016 8.05667 3.22416 7.83301 3.50016 7.83301H4.01514C4.00647 7.72301 4.00016 7.61234 4.00016 7.49967C4.00016 7.38701 4.00647 7.27634 4.01514 7.16634H3.50016C3.22416 7.16634 3.00016 6.94267 3.00016 6.66634C3.00016 6.39001 3.22416 6.16634 3.50016 6.16634H4.22021C4.68322 4.80267 5.83101 3.83301 7.17334 3.83301Z"
                        fill="#63B15B"
                      />
                    </svg>
                  </span>
                  {{ details.offer.compensation }} Euro
                </p>
                <p
                  class="
                    flex
                    align-center
                    justify-end
                    mt-2
                    mb-0
                    text-xs
                    font-medium
                    text-darkgray1
                  "
                >
                  {{ $t("pages.common.buttons.dis15") }}:
                  {{
                    formatDate(
                      details.offer.arrival_date,
                      "DD.MM.YYYY",
                      "YYYY-MM-DD"
                    )
                  }}
                </p>
              </div>
            </div>

            <div
              class="
                flex
                items-center
                justify-start
                relative
                pt-2.5
                pb-2.5
                pl-3
                pr-3
                bg-lightpink
                text-darkblack text-xs
                walter-footer
                flex-wrap
              "
            >
              <span class="icon mr-1.5">
                <svg
                  class="w-3 h-3"
                  viewBox="0 0 12 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M11.1622 0.326311C11.0301 0.32943 10.9047 0.384665 10.8132 0.479957L6.00008 5.29311L1.18693 0.479957C1.14032 0.431962 1.08456 0.393806 1.02294 0.36775C0.961323 0.341694 0.895103 0.328267 0.828203 0.328265C0.728696 0.328289 0.631458 0.358001 0.548932 0.413598C0.466406 0.469196 0.402343 0.548151 0.364942 0.640362C0.32754 0.732572 0.3185 0.833845 0.338978 0.931222C0.359456 1.0286 0.408521 1.11765 0.479896 1.18699L5.29305 6.00014L0.479896 10.8133C0.43191 10.8594 0.393599 10.9146 0.367208 10.9756C0.340816 11.0367 0.326874 11.1024 0.326198 11.1689C0.325521 11.2354 0.338125 11.3014 0.363269 11.363C0.388414 11.4246 0.425594 11.4805 0.472633 11.5276C0.519672 11.5746 0.575624 11.6118 0.637212 11.637C0.6988 11.6621 0.764786 11.6747 0.831306 11.674C0.897825 11.6733 0.963542 11.6594 1.02461 11.633C1.08567 11.6066 1.14085 11.5683 1.18693 11.5203L6.00008 6.70717L10.8132 11.5203C10.8593 11.5683 10.9145 11.6066 10.9755 11.633C11.0366 11.6594 11.1023 11.6733 11.1688 11.674C11.2354 11.6747 11.3014 11.6621 11.3629 11.6369C11.4245 11.6118 11.4805 11.5746 11.5275 11.5276C11.5746 11.4805 11.6117 11.4246 11.6369 11.363C11.662 11.3014 11.6746 11.2354 11.674 11.1689C11.6733 11.1024 11.6593 11.0367 11.6329 10.9756C11.6066 10.9146 11.5682 10.8594 11.5203 10.8133L6.70711 6.00014L11.5203 1.18699C11.593 1.1172 11.6429 1.02707 11.6635 0.928421C11.6841 0.829768 11.6744 0.727192 11.6357 0.634143C11.597 0.541094 11.531 0.461913 11.4466 0.406981C11.3621 0.35205 11.2629 0.323931 11.1622 0.326311Z"
                    fill="#EE5B64"
                  />
                </svg>
              </span>
              <span class="text-xs mr-1.5 font-medium">
                Andere Bewerbung ausgewählt
              </span>
            </div>
          </div>
        </div>
        <p
          class="
            block
            text-lightGrey text-sm
            font-fold
            mt-4
            mb-10
            title-block
            text-center
            pl-4
            pr-4
          "
        >
          {{ $t("pages.dont_show_family.no_longer_display") }}
        </p>

        <div class="block relative form-group mb-4">
          <button
            class="
              relative
              flex
              items-center
              justify-center
              flex-nowrap
              text-darkblack text-sm
              walter-footer
              pt-3
              pb-3
              pl-4
              pr-4
              border
              solid
              border-darkgreen
              rounded
              btn-transparent
              w-full
              text-center
            "
            @click="toggleCustomer"
          >
            <span class="flex mr-2.5">
              <svg
                class="w-4.5 h-5"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M18.75 6.93751L17.76 5.78579C16.9206 4.90415 15.9106 4.20252 14.7914 3.7236C13.6722 3.24468 12.4673 2.99849 11.25 3.00001C6.28125 3.00001 2.25 7.03126 2.25 12C2.25 16.9688 6.28125 21 11.25 21C13.1114 20.9999 14.927 20.4229 16.447 19.3484C17.967 18.2739 19.1166 16.7548 19.7377 15"
                  stroke="#63B15B"
                  stroke-width="1.5"
                  stroke-miterlimit="10"
                  stroke-linecap="round"
                />
                <path
                  d="M21.75 3.20913V10.313C21.75 10.3628 21.7303 10.4105 21.6951 10.4456C21.66 10.4808 21.6123 10.5005 21.5625 10.5005H14.4586C14.4215 10.5006 14.3853 10.4896 14.3544 10.469C14.3235 10.4484 14.2995 10.4191 14.2853 10.3848C14.2711 10.3505 14.2674 10.3128 14.2746 10.2764C14.2819 10.24 14.2997 10.2066 14.326 10.1804L21.4299 3.07648C21.4561 3.05022 21.4895 3.03234 21.5259 3.0251C21.5623 3.01785 21.6 3.02156 21.6343 3.03577C21.6686 3.04997 21.6979 3.07402 21.7185 3.10489C21.7391 3.13575 21.7501 3.17203 21.75 3.20913V3.20913Z"
                  fill="#63B15B"
                />
              </svg>
            </span>
            <span class="text-sm mr-1 font-semibold text-darkgreen">
              {{ $t("pages.dont_show_family.show_family") }}
            </span>
          </button>
        </div>
        <div class="form-group mb-2 w-full">
          <button
            class="
              w-full
              flex
              items-center
              justify-center
              btn_apply
              rounded-lg
              text-white
              h-auto
            "
            @click="$router.push({ name: 'offerSearch' })"
          >
            {{ $t("pages.dont_show_family.search_button_text") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "DontShowFamily",
  computed: {
    ...mapGetters("application", {
      details: "selected",
    }),
  },
  methods: {
    toggleCustomer() {
      this.$store.commit("app/showNotification", {
        heading: "Familie doch anzeigen?",
        desc: "Diese Familie wird Ihnen in der Zukunft doch in der Suche angezeigt werden.",
        buttons: {
          okay: {
            text: "Familie anzeigen",
            action: () => {
              this.loading = true;
              this.$store
                .dispatch(
                  "offer/toggleCustomer",
                  this.details.offer.customer.id
                )
                .then(() => {
                  this.loading = false;
                  this.$router.push({ name: "offerSearch" });
                });
            },
          },
          cancel: {
            text: "Abbrechen",
            action: () => {
              this.loading = false;
            },
          },
        },
      });
    },
  },
};
</script>
